module.exports = __webpack_public_path__ + "static/img/3.c8326c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/servicios/3.png
// module id = tVzB
// module chunks = 0